import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'label step title',
    defaultMessage: 'Select a label layout <span>{emoji}</span>',
    id: 'gvYsAe',
  },
  description: {
    description: 'label step description',
    defaultMessage:
      'Let us know which label format and size works best for your business, and we’ll apply it to all of your labels across all of your carriers.',
    id: 'KY8mNU',
  },
  addMessage: {
    description: 'label step add message',
    defaultMessage: 'Select a Label Layout',
    id: 'keNRyw',
  },
  changeMessage: {
    description: 'label step change message',
    defaultMessage: 'Change label layout',
    id: 'wKVFkT',
  },
  saveSuccessMessage: {
    description: 'select a label step growler success message',
    defaultMessage: 'Label layout saved successfully',
    id: 'az9PiC',
  },
  labelLayoutButton: {
    description: 'label layout button',
    defaultMessage: 'Set layout',
    id: 'hHaZGV',
  },
  addTaxIDButton: {
    description: 'add tax id button',
    defaultMessage: 'Add Tax ID',
    id: 'r2dIvs',
  },
});

export default messages;
